import fmt from 'date-fns/format';
import isBefore from 'date-fns/isBefore';
import locale from './themes/BGH/locale';
import { rm } from './resource';
import { isSameMonth, startOfMonth, subDays } from 'date-fns';

export const isSameDay = (dateLeft: Date, dateRight: Date) => {
  const cleanDateLeft = new Date(dateLeft);
  const cleanDateRight = new Date(dateRight);

  cleanDateLeft.setHours(0, 0, 0, 0);
  cleanDateRight.setHours(0, 0, 0, 0);

  return cleanDateLeft.getTime() === cleanDateRight.getTime();
};

export const IsBefore = (date: Date, dateToCompare: Date) => isBefore(date, dateToCompare);

export const addDays = (date: Date, numDays: number) => {
  const cleanDate = new Date(date);
  cleanDate.setDate(cleanDate.getDate() + numDays);
  return cleanDate;
};

export const subtractDays = (date: Date, numDays: number) => {
  return addDays(date, -numDays);
};

export const getDateRange = (start: Date, end: Date) => {
  const dates = [] as Date[];
  let current = start;
  while (current <= end) {
    dates.push(new Date(current));
    current = addDays(current, 1);
  }
  return dates;
};

const format = (format: string) => (date: Date) => fmt(date, format, { locale });
export const formatDateShort = format('P');

export const getMonthName = (dateOrMonth: Date | number): string => {
  let month: number;
  if (typeof dateOrMonth === 'object' && 'getMonth' in dateOrMonth) {
    month = dateOrMonth.getMonth();
  } else {
    month = dateOrMonth;
  }
  const monthNames = [
    'month_jan',
    'month_feb',
    'month_mar',
    'month_apr',
    'month_may',
    'month_jun',
    'month_jul',
    'month_aug',
    'month_sep',
    'month_oct',
    'month_nov',
    'month_dec'
  ];

  return rm(monthNames[month]);
};

/**
 * Takes a day and returns all dates within that month,
 * including dates from previous/next month that might occur in the first/last week of the specified month.
 * @param day The specified day
 * @returns List of dates to show
 */
export const DaysInMonth = (day: Date) => {
  const daysToShow = [];
  const month = startOfMonth(day);
  const previousMonth = subDays(month, 1);
  let firstDayOfMonth = month.getDay();

  if (firstDayOfMonth === 0) {
    firstDayOfMonth = 7;
  }

  while (firstDayOfMonth > 1) {
    daysToShow.unshift(new Date(previousMonth));

    previousMonth.setDate(previousMonth.getDate() - 1);

    firstDayOfMonth--;
  }

  while (isSameMonth(month, day) || month.getDay() !== 1) {
    daysToShow.push(new Date(month));

    month.setDate(month.getDate() + 1);
  }

  return daysToShow;
};

export const isRangeWithinInterval = (
  day: Date,
  rangeStartDate: Date,
  rangeEndDate: Date
): boolean => {
  if (rangeStartDate < rangeEndDate) {
    return (
      dayIsLaterOrEqualToDate(day, rangeStartDate) && dayIsEarlierOrEqualToDate(day, rangeEndDate)
    );
  }
  return (
    dayIsLaterOrEqualToDate(day, rangeEndDate) && dayIsEarlierOrEqualToDate(day, rangeStartDate)
  );
};

const dayIsLaterOrEqualToDate = (day: Date, dateToEvaluate: Date): boolean => {
  return day >= dateToEvaluate;
};

const dayIsEarlierOrEqualToDate = (day: Date, dateToEvaluate: Date): boolean => {
  return day <= dateToEvaluate;
};
